'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _placeholders = require('../transforms/placeholders');

exports.default = function secondPass(compiler, path) {
  if (compiler.opts.placeholderArgs) {
    (0, _placeholders.transformAllPlaceholders)(path);
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/visitors/secondPass.js
// module id = 1005
// module chunks = 0